import React from "react";

import { Button, Icon, IconProps, Typography } from "components";

interface GuidanceLinkProps {
  dataTestId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  text: string;
  disabled?: boolean;
  variant?: "grey" | "light";
  iconSize?: IconProps["size"];
}

export const GuidanceLink = ({ dataTestId, disabled, onClick, text, variant, iconSize }: GuidanceLinkProps) => (
  <Button
    type="text"
    dataTestId={dataTestId}
    disabled={disabled}
    className={`guidance-link padding-50 ${variant ?? ""}`}
    onClick={onClick}
    icon={<Icon iconName="tabler/info-circle" size={iconSize} />}
  >
    <Typography variant="paragraph-m" className="guidance-link-content">
      {text}
    </Typography>
  </Button>
);
